/**
 * Utility for accessing environment variables consistently across environments
 * Works both with:
 * - Create React App process.env.REACT_APP_* variables (development/build time)
 * - Docker runtime environment variables (window.__RUNTIME_CONFIG__)
 */

// Runtime values take precedence over build time values, but only if they're real values (not placeholders)
const getEnvConfig = () => {
    // Check for Docker runtime config - but only if values are not placeholders
    if (window.__RUNTIME_CONFIG__) {
        const runtimeConfig = window.__RUNTIME_CONFIG__;
        
        // Check if we have real values (not placeholders like {{REACT_APP_API_BASE_URL}})
        const hasRealValues = runtimeConfig.REACT_APP_API_BASE_URL && 
                              !runtimeConfig.REACT_APP_API_BASE_URL.includes('{{') &&
                              !runtimeConfig.REACT_APP_API_BASE_URL.includes('}}');
        
        if (hasRealValues) {
            return {
                ...runtimeConfig,
                REACT_APP_VERSION: runtimeConfig.REACT_APP_VERSION || process.env.REACT_APP_VERSION || '0.0.0'
            };
        }
    }
    
    // Use process.env values (development/build time)
    return {
        REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
        REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
        REACT_APP_DEBUG: process.env.REACT_APP_DEBUG || 'true',
        REACT_APP_VERSION: process.env.REACT_APP_VERSION || '0.0.0',
        REACT_APP_API_USERNAME: process.env.REACT_APP_API_USERNAME || '',
        REACT_APP_API_PASSWORD: process.env.REACT_APP_API_PASSWORD || ''
    };
};

/**
 * Get environment variables safely
 * @returns {Object} Environment configuration object
 */
export const getConfig = () => {
    const config = getEnvConfig();
    
    return {
        apiBaseUrl: config.REACT_APP_API_BASE_URL,
        environment: config.REACT_APP_ENVIRONMENT,
        debug: config.REACT_APP_DEBUG === 'true',
        version: config.REACT_APP_VERSION,
        apiUsername: config.REACT_APP_API_USERNAME,
        apiPassword: config.REACT_APP_API_PASSWORD
    };
};

export default getConfig;